<template>
  <v-dialog
    v-model="dialog"
    width="400px"
    @closed="closed">
    <div class="header flex">
      <p>{{step == 2? 'Confirm ' : ''}}Add/Subtract Hold Dollar</p>
      <font-awesome-icon
        icon="times"
        class="close"
        @click="handleCancel"></font-awesome-icon>
    </div>
    <div class="body">
      <div
        v-show="step == 1"
        class="main">
        <el-form
          ref="form"
          :model="formData"
          :rules="formRule">
          <div class="form-item">
            <span>Customer</span>
            <el-form-item>
              <v-input
                :value="customer.nick_name"
                disabled></v-input>
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Amount</span>
            <el-form-item prop="amount">
              <v-input
                v-model="formData.amount"
                int
                money
                negativeMoney
              ></v-input>
            </el-form-item>
          </div>
          <div class="form-item">
            <span class="flex flex-sb">
              <span>Reason</span>
              <span class="tips">
                <font-awesome-icon
                  class="icon"
                  icon="eye-slash" />
                Hidden from customer
              </span>
            </span>
            <el-form-item prop="reason">
              <v-input v-model="formData.reason"></v-input>
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Remark</span>
            <el-form-item prop="remark">
              <v-input
                v-model="formData.remark"
                type="textarea"
                :rows="6"></v-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div
        v-show="step == 2"
        class="main">
        <div class="tr">
          <div class="left">Date</div>
          <div class="right">{{date}}</div>
        </div>
        <div class="tr">
          <div class="left">Customer</div>
          <div class="right">{{customer.nick_name}}</div>
        </div>
        <div class="tr">
          <div class="left">CS</div>
          <div class="right">{{customer.cs_name}}</div>
        </div>
        <div class="tr">
          <div class="left">Hold Dollars</div>
          <div class="right">{{formData.amount}}</div>
        </div>
        <div class="tr">
          <div class="left">Reason</div>
          <div class="right">{{formData.reason}}</div>
        </div>
        <div class="tr">
          <div class="left">Remarks</div>
          <div class="right">{{formData.remark}}</div>
        </div>
      </div>
      <div class="footer">
        <div class="btn flex">
          <v-button
            gray
            @click="handleCancel">Cancel</v-button>
          <v-button
            v-if="step == 1"
            green
            @click="handleContinue">Continue</v-button>
          <v-button
            v-else
            green
            @click="handleConfirm">Confirm</v-button>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import {editCredit} from '@/api/referral'
import dayjs from 'dayjs'
export default {
  name: 'HolddollarDialog',
  props:{
    customer:{
      type: Object,
      default: () => {}
    }
  },
  data () {
    const checkAmount = (rule, value, cb) => {
      if(!value && value !== 0){
        cb(new Error(this.$t('placeholder.input')))
      }
      if(Number(value) === 0) {
        cb(new Error('Amount不能為0'))
      }
      cb()
    }
    return {
      dialog: false,
      formData:{
        amount: '',
        reason: '',
        remark: '',
      },
      formRule:{
        amount:[
          {validator: checkAmount, trigger: ['change', 'blur'] }
        ]
      },
      step: 1,
    }
  },
  computed:{
    date(){
      return dayjs().format('DD-MM-YYYY')
    }
  },
  methods: {
    changeDialog(){
      this.dialog = !this.dialog
    },
    handleCancel(){
      this.changeDialog()
    },
    handleContinue(){
      this.$refs['form'].validate(valid =>{
        if(valid){
          this.step = 2
        }
      })
    },
    handleConfirm(){
      this.network().editCredit({
        ...this.formData,
        user_id: this.customer.id
      })
    },

    closed(){
      this.step = 1
    },

    network(){
      return {
        editCredit: async(params) =>{
          const {data} = await editCredit(params)
          const {code} = data
          if(code == 1000){
            this.$message({
              type: 'success',
              message: 'Success'
            })
            this.$refs['form'].resetFields()
            this.handleCancel()
            this.$emit('update')
          }
        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>
/deep/.el-dialog{
  border-radius: 6px;
  .header{
    background: #F6F8FA;
    border: 1px solid #E1E4E8;
    border-radius: 6px 6px 0px 0px;
    padding: 16px;
    justify-content: space-between;
    align-items: center;
    p{
      font-weight: 600;
      font-size: 14px;
      height: 20px;
      color: #1B1F23;
    }
    .close{
      padding: 0 5px;
      cursor: pointer;
    }
  }
  .body{
    padding: 20px 15px 15px 15px;
    .top{
      color: #24292E;
    }
    .main{
      .flex{
        display: flex !important;
        align-items: center;
        .tips{
          font-weight: 400;
          font-size: 16px;
          line-height: 24px;
          color: #586069;
          .icon{
            margin-right: 14px;
          }
        }
      }
      .tr{
        display: flex;
        .left{
          font-weight: 400;
          font-size: 12px;
          line-height: 18px;
          color: #24292E;
          margin-right: 15px;
          width: 100px;
        }
        .right{
          font-weight: 600;
          font-size: 12px;
          line-height: 18px;
          color: #6A737D;
          overflow-wrap: break-word;
          flex: 1;
        }
      }
    }
    .footer{
      margin-top: 20px;
      .btn{
        justify-content: space-between;
      }
    }
  }
}
</style>
